import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { ContainedButton, Dialog, TextButton } from '@shared/components';
import { DeletionFromDateForm } from './DeletionFromDateForm';
import { useForm } from 'react-hook-form';
import { expireItemsSchema, ExpireItemsSchema } from './expireItemsSchema';
import { useAppTFunction } from '@retail/app/i18n';
import { yupResolver } from '@hookform/resolvers/yup';

interface Props {
  isOpen: boolean;
  numberOfItems: number;
  isDeleting: boolean;
  onClose: () => void;
  onDelete: (validTo?: Date) => void;
}

export function DeleteItemsDialog({ numberOfItems, isOpen, onClose, isDeleting, onDelete }: Props) {
  const t = useAppTFunction();

  const { control, handleSubmit } = useForm<ExpireItemsSchema>({
    resolver: yupResolver(expireItemsSchema(t)),
    mode: 'onSubmit',
    defaultValues: {
      fromDate: null,
    },
  });

  const onSubmit = handleSubmit(({ fromDate }) => {
    onDelete(fromDate ?? undefined);
  });

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {numberOfItems === 1
          ? t('assortment.deleteItems.titleSingular', { numItems: numberOfItems })
          : t('assortment.deleteItems.titlePlural', { numItems: numberOfItems })}
      </DialogTitle>

      <DialogContent>
        <DeletionFromDateForm control={control} />
      </DialogContent>

      <DialogActions>
        <TextButton onClick={onClose} disabled={isDeleting} size="small">
          {t('common.cancel')}
        </TextButton>
        <ContainedButton loading={isDeleting} onClick={onSubmit} size="small">
          {t('assortment.deleteItems.confirm')}
        </ContainedButton>
      </DialogActions>
    </Dialog>
  );
}
